const CUSTOMER_INFO_KEY = 'gongsegae_customer_info';

export interface CustomerInfo {
  name: string;
  phone: string;
  email?: string;
}

/**
 * Save customer information to localStorage
 */
export function saveCustomerInfo(name: string, phone: string, email?: string): void {
  try {
    const customerInfo: CustomerInfo = {
      name,
      phone,
      email,
    };
    localStorage.setItem(CUSTOMER_INFO_KEY, JSON.stringify(customerInfo));
  } catch (error) {
    console.error('Failed to save customer info to localStorage:', error);
  }
}

/**
 * Load customer information from localStorage
 */
export function loadCustomerInfo(): CustomerInfo | null {
  try {
    const stored = localStorage.getItem(CUSTOMER_INFO_KEY);
    if (!stored) return null;

    const customerInfo = JSON.parse(stored) as CustomerInfo;
    return customerInfo;
  } catch (error) {
    console.error('Failed to load customer info from localStorage:', error);
    return null;
  }
}

/**
 * Clear customer information from localStorage
 */
export function clearCustomerInfo(): void {
  try {
    localStorage.removeItem(CUSTOMER_INFO_KEY);
  } catch (error) {
    console.error('Failed to clear customer info from localStorage:', error);
  }
}
